<div>
  <!-- NOTE: When using cor-dialog-box, the styling looks very different. Not too sure why...
             So, using p-dialog directly  -->
  <p-dialog
    [modal]="true"
    [(visible)]="isSearchPanelVisible"
    [draggable]="false"
    [showHeader]="false"
    (onHide)="onSearchDialogHide()"
    position="top"
    [style]="{ width: '100%', maxWidth: '45rem', 'border-radius': '0.6rem' }"
    [dismissableMask]="true"
    [contentStyle]="{ border: '0', padding: '0rem', background: 'transparent' }"
    [resizable]="false">
    <div class="tw:relative">
      <p-autoComplete
        class="tw:grow"
        test-id="global-search"
        [inputStyle]="{ width: '100%', maxWidth: '45rem', padding: '1rem', 'font-size': '1rem' }"
        placeholder="Search Corridor..."
        [style]="{ width: '100%' }"
        [virtualScrollOptions]="{
          step: 20,
          lazy: true,
          scrollHeight: '60vh',
        }"
        scrollHeight="60vh"
        [showClear]="true"
        [minLength]="3"
        [autofocus]="true"
        ariaLabel="Search Corridor"
        [formControl]="searchText"
        appendTo="body"
        panelStyleClass="global-search-panel"
        (onClear)="onClear()"
        optionLabel="name"
        [suggestions]="suggestions()"
        (onLazyLoad)="onSearchScroll($event)"
        [virtualScrollItemSize]="50"
        (completeMethod)="setupSearchTextListener($event)"
        [virtualScroll]="suggestions().length > 0"
        [autoOptionFocus]="true"
        [emptyMessage]="isLoading() ? 'Loading data...' : 'No matching found!'"
        (onSelect)="navigateToSelectedItem($event)"
        (onFocus)="onAutoCompleteFocus()">
        <!-- Header Template -->
        <ng-template pTemplate="header">
          <div class="tw:flex tw:items-center tw:pt-2 tw:px-3">
            <label>
              {{ searchText.value.length === 0 ? 'Recent Items' : 'Search Results ' }}
              {{ pageInfo.totalItems() > 0 ? '(' + pageInfo.totalItems() + ' items)' : '' }}
            </label>
          </div>
        </ng-template>

        <ng-template pTemplate="empty">
          @if (isLoading()) {
            <div class="tw:flex tw:items-center tw:flex-col tw:gap-2">
              @for (skeleton of [0, 1, 2, 3, 4]; track $index) {
                <p-skeleton
                  width="100%"
                  height="4rem" />
              }
            </div>
          } @else {
            <div class="tw:flex tw:justify-center">
              <cor-no-data
                [noDataMessage]="
                  searchText.value.length > 0
                    ? 'We couldn’t find any results for your search'
                    : 'We couldn’t find any recent items'
                "
                [showIcon]="true" />
            </div>
          }
        </ng-template>
        <!-- Option Item Template -->
        <ng-template
          let-item
          pTemplate="item">
          <div
            [attr.test-id]="'global-search-option-' + item.name"
            class="tw:grid tw:w-full tw:min-w-0 tw:max-w-full tw:grid-cols-[2.75rem_minmax(0,1fr)_auto_1.125rem] tw:items-center tw:gap-x-3 tw:overflow-hidden tw:px-2">
            <div
              class="tw:flex tw:size-11 tw:min-w-0 tw:items-center tw:justify-center tw:rounded-full"
              [title]="$any(OBJECT_DISPLAY_NAMES)[item.objectType]"
              [ngStyle]="item.objectType | objectIconPipe">
              <i
                [ngClass]="(item.objectType | objectIconPipe)?.icon"
                style="color: inherit; font-size: 1.2rem"></i>
            </div>
            <div class="tw:flex tw:min-w-0 tw:max-w-full tw:flex-col tw:overflow-hidden details">
              <div class="tw:flex tw:min-w-0 tw:max-w-full tw:items-center tw:overflow-hidden">
                <span
                  class="tw:block tw:min-w-0 tw:flex-1 tw:truncate"
                  [title]="item.name">
                  {{ item.name }}

                  @if (item.version) {
                    <p-tag
                      severity="info"
                      rounded
                      [value]="'v' + item.version"
                      class="tw:ms-2 tw:shrink-0" />
                  }
                </span>
              </div>
              @if (item.createdByVisibleName || item.createdBy) {
                <small class="tw:block tw:min-w-0 tw:max-w-full tw:truncate tw:text-muted-color">
                  Created by
                  <strong>{{ item.createdByVisibleName || item.createdBy }}</strong>
                  , {{ item.createdDate | dateFromNow }}
                </small>
              }
            </div>
            <div class="tw:flex tw:min-w-0 tw:items-center tw:justify-center">
              @if (item.currentStatus) {
                <cor-status-icon [status]="item.currentStatus" />
              }
            </div>
            <div class="tw:flex tw:min-w-0 tw:items-center tw:justify-center">
              <i class="pi pi-arrow-up-right tw:text-slate-400"></i>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="footer">
          <div
            class="tw:flex tw:flex-col tw:px-3 tw:pt-2 tw:pb-3 tw:gap-2 tw:border-t tw:border-surface">
            <div>
              <label class="tw:text-muted-color">Quick Actions</label>
            </div>
            <div class="tw:flex tw:flex-wrap tw:gap-2">
              <p-button
                test-id="global-search-new-table"
                [buttonProps]="{ autofocus: false }"
                (click)="openCreatePage(OBJECTS.DATA_TABLE)"
                severity="secondary"
                size="small"
                [icon]="OBJECT_INFO[OBJECTS.DATA_TABLE].icon"
                label="New Table" />
              <p-button
                test-id="global-search-new-model"
                [buttonProps]="{ autofocus: false }"
                (click)="openCreatePage(OBJECTS.FOUNDATION_MODEL)"
                severity="secondary"
                size="small"
                [icon]="OBJECT_INFO[OBJECTS.FOUNDATION_MODEL].icon"
                label="New Model" />
              <p-button
                test-id="global-search-new-pipeline"
                [buttonProps]="{ autofocus: false }"
                (click)="openCreatePage(OBJECTS.PIPELINE)"
                severity="secondary"
                size="small"
                [icon]="OBJECT_INFO[OBJECTS.PIPELINE].icon"
                label="New Pipeline" />
            </div>
          </div>
        </ng-template>
      </p-autoComplete>
      <i
        class="pi pi-search tw:absolute tw:left-2 tw:top-1/2 tw:-translate-y-1/2 tw:text-base tw:text-muted-color"
        aria-hidden="true"></i>
    </div>
  </p-dialog>
</div>
